<div class="container d-flex justify-content-center">
  <div class="spinner-border spinner-center"></div>
</div>
